// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logoContainer":"LinkedLogo_logoContainer__nciU0","logo":"LinkedLogo_logo__-ZpeB","logoMobile":"LinkedLogo_logoMobile__tUIxn"};